import { render, staticRenderFns } from "./KeyResultProgress.vue?vue&type=template&id=04ef980b&"
import script from "./KeyResultProgress.vue?vue&type=script&lang=js&"
export * from "./KeyResultProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports